import { render, staticRenderFns } from "./Protocols.vue?vue&type=template&id=0d601c4a&"
import script from "./Protocols.vue?vue&type=script&lang=js&"
export * from "./Protocols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports